export default function AjudaPage() {
  return (
    <div style={{ padding: "30px", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Ajuda</h1>

      <p>
        Se você tiver dúvidas sobre a plataforma, cadastro de afiliada,
        funcionamento dos links ou navegação, esta área será usada para suporte.
      </p>

      <p>
        Em breve você poderá adicionar WhatsApp, formulário de contato ou FAQ.
      </p>
    </div>
  );
}